//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UpcomingRecipientsTable from "./upcoming-recipients-table";
import { GenericModal } from "@Shared/components/modals";
import RefreshButton from "@Shared/components/buttons/refresh-button.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "UpcomingRecipientsModal",
  components: {
    GenericModal,
    UpcomingRecipientsTable,
    RefreshButton
  },
  props: {
    automation: {
      type: Object,
      default: () => ({})
    },
    time: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      refreshing: false
    };
  },
  computed: {
    actionArguments() {
      return this.automation["action-arguments"];
    },
    timeValue() {
      return Math.abs(this.time.value);
    },
    dateType() {
      return this.time.type;
    },
    triggerName() {
      return this.automation["trigger-arguments"].name;
    },
    isRenewalAutomation() {
      return this.automation.trigger === "mortgage_renewal_date" ? true : false;
    }
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    refreshRecipients() {
      this.$refs.upcomingTable.refreshData();
    },
    handleGoToClientApp(applicationInfo) {
      const {
        applicationId,
        agentUsername,
        clientUsername
      } = applicationInfo;
      this.$refs.modal.hide();
      this.$router.push({
        name: "application",
        params: {
          agentUsername,
          applicationId,
          clientUsername
        }
      });
    }
  }
});